export const events_page = () => {

    $("#availableMembersList").DataTable({
        order: [2, 'asc'],
        stateSave: false,
        columnDefs:[
            {
                targets: [1, 2],
                type: 'polstring',
            }
        ]
    });

    if($("#availableMembersList").length > 0) {
        $("#addEvent").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableMembersList").DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="users_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    $("#inviteToEvent").submit(function(e) {
        e.preventDefault();
        let checkboxes = $('#members').DataTable().api().checkedCheckboxes();

        for(let checkbox of checkboxes) {
            $(this).append($(checkbox).clone().attr('type', 'hidden'));
            $(checkbox).attr('name', 'member_old[]');
        }

        this.submit();
    })

    $("#members").DataTable({
        stateSave: false,
        order: [2, 'asc'],
        columnDefs:[
            {
                targets: [1,2],
                type: 'polstring'
            }
        ]
    })

    $("#timesheet").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
        columnDefs:[
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    })

    $("#eventList").DataTable({
        "order": [[0, "desc"]],
        "stateSave": false,
    })


}
